import React, { useState, useEffect, useContext } from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import Select from '../../Elements/Select';
import { ContextBuilder } from '../../../../context/builder/reducers';

const DragHandle = SortableHandle(props => (
    <div className="drag-point">
        <i className="fas fa-sort"></i>
    </div>
));

const Sortable = SortableElement(props => {
    const { state, dispatch } = useContext(ContextBuilder);
    let employees = state.employees || [];
    return (
        <div className="sortable-item col-6">
            <div className="d-flex">
                <div>
                    <DragHandle {...props} />
                    <div className="delete-point" index={props.itemIndex} onClick={props.deleteButtonHandler}>
                        <i className="far fa-trash-alt"></i>
                    </div>
                </div>
                <div className="col pt-4">
                    <Select className="form-control" value={props.element.employees}
                            name={`elements.${props.itemIndex}.employees`} onChange={props.onChange}>
                        {employees.map((item, i) => {
                            return (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                </Select.Option>
                            );
                        })}
                    </Select>
                </div>
            </div>
        </div>
    );
})

export default Sortable;
